import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import EventGroupFields from './EventGroupFields'

export const EventGroupEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <EventGroupFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default EventGroupEdit
